import * as googleMaps from "@googlemaps/js-api-loader";
import { GOOGLE_MAPS_API_VERSION } from "@voltalis/frontend-utils";

import { loadDeprecatedEnv } from "@/env.deprecated.ts";

export type TGoogleMapsLanguageCode = "fi" | "fr" | "sl" | "sv" | "en-GB" | "es" | "cs" | "hu";

let loader!: googleMaps.Loader;

function getLoader() {
  if (loader) {
    return loader;
  }

  loader = new googleMaps.Loader({
    apiKey: loadDeprecatedEnv().VITE_GOOGLE_MAPS_API_KEY,
    version: GOOGLE_MAPS_API_VERSION,
    libraries: ["places"],
  });

  return loader;
}

export async function getPlaces() {
  return await getLoader().importLibrary("places");
}

// https://developers.google.com/maps/documentation/javascript/geocoding?hl=fr#GeocodingAddressTypes
export enum EGoogleAddressType {
  STREET_ADDRESS = "street_address",
  ROUTE = "route",
  INTERSECTION = "intersection",
  POLITICAL = "political",
  COUNTRY = "country",
  ADMINISTRATIVE_AREA_LEVEL_1 = "administrative_area_level_1",
  ADMINISTRATIVE_AREA_LEVEL_2 = "administrative_area_level_2",
  ADMINISTRATIVE_AREA_LEVEL_3 = "administrative_area_level_3",
  ADMINISTRATIVE_AREA_LEVEL_4 = "administrative_area_level_4",
  ADMINISTRATIVE_AREA_LEVEL_5 = "administrative_area_level_5",
  ADMINISTRATIVE_AREA_LEVEL_6 = "administrative_area_level_6",
  ADMINISTRATIVE_AREA_LEVEL_7 = "administrative_area_level_7",
  COLLOQUIAL_AREA = "colloquial_area",
  LOCALITY = "locality",
  SUBLOCALITY = "sublocality",
  SUBLOCALITY_LEVEL_1 = "sublocality_level_1",
  NEIGHBORHOOD = "neighborhood",
  PREMISE = "premise",
  SUBPREMISE = "subpremise",
  PLUS_CODE = "plus_code",
  POSTAL_CODE = "postal_code",
  POSTAL_CODE_PREFIX = "postal_code_prefix",
  NATURAL_FEATURE = "natural_feature",
  AIRPORT = "airport",
  PARK = "park",
  POINT_OF_INTEREST = "point_of_interest",
  FLOOR = "floor",
  ESTABLISHMENT = "establishment",
  LANDMARK = "landmark",
  PARKING = "parking",
  POST_BOX = "post_box",
  POSTAL_TOWN = "postal_town",
  ROOM = "room",
  STREET_NUMBER = "street_number",
  BUS_STATION = "bus_station",
}
